import { Title } from '../../components/Title/Title';
import { Topbar } from '../../components/Topbar/Topbar';
import { Alert, Badge, Button, Card, Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckSquare, faUserCheck, faVial } from '@fortawesome/free-solid-svg-icons';
import { Footer } from '../../components/Footer/Footer';
import { useEffect, useState } from 'react';
import { FullscreenLoader } from '../../components/FullscreenLoader/FullscreenLoader';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { Experiments, innerHtml } from '../../utils/utils';
import { faSquare } from '@fortawesome/free-regular-svg-icons';
import { Copyable } from '../../components/Copyable/Copyable';
import { AdminNotes } from '../../components/AdminNotes/AdminNotes';
import { WithTooltip } from '../../components/WithTooltip/WithTooltip';

const LabComponent = () => {
  const { getExperiments, userDataFmt, database, currentUser, fv } = useFirebase();
  const [experiments, setExperiments] = useState<any[]>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    _getExperiments();
  }, []);

  const _getExperiments = () => {
    setExperiments(null);
    getExperiments().then(setExperiments).catch(console.error);
  };

  const hasExperiment = (experiment: Experiments): boolean => {
    return !!userDataFmt.experiments?.[experiment];
  };

  const toggleExperiment = (id: string, experiment: Experiments) => {
    setLoading(true);

    Promise.all([
      database.doc(`userData/${currentUser.uid}`).set({ experiments: { [experiment]: !hasExperiment(experiment) } }, { merge: true }),
      database.doc(`experiments/${id}`).update({ usersActive: fv.increment(hasExperiment(experiment) ? -1 : 1) }),
    ])
      .then(() => window.location.reload())
      .catch(console.error)
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Title>Lab</Title>

      <div style={{ marginBottom: '72px' }}>
        <div style={{ backgroundColor: '#141414', position: 'fixed', top: '0', left: '0', right: '0', zIndex: 100 }}>
          <Topbar />
        </div>
      </div>

      <Container className={'my-5'}>
        <div className={'d-flex align-items-center'}>
          <div className={'display-4'}>Lab</div>
        </div>

        <div className={'mt-4'}>
          Da questa sezione, gli utenti amministratori potranno attivare funzionalità esclusive, prima che queste siano rilasciate. &Egrave; caldamente
          consigliato lasciare un feedback su un determinato esperimento quando questo viene provato, così da facilitare la risoluzione di problemi o il
          miglioramento dell'esperienza utente.
          <br />
          <strong>L'attivazione di un esperimento riguarda solamente sé stessi, e non gli altri utenti!</strong>
        </div>

        <div className={'mt-4'}>
          {!experiments && <FullscreenLoader fullscreen={false} />}
          {!!experiments && (
            <>
              {!!experiments?.length && (
                <div className={'text-center'} style={{ fontSize: '1.2rem' }}>
                  <Badge variant={'success'} className={'mb-2'}>
                    <FontAwesomeIcon icon={faVial} className={'mr-2'} />
                    Esperimenti attivi: {experiments.filter((e) => hasExperiment(e.humanReadableId)).length}
                  </Badge>
                </div>
              )}
              {!experiments.length && <Alert variant={'warning'}>Nessun esperimento attivabile al momento.</Alert>}
              {!!experiments.length &&
                experiments.map((exp) => (
                  <Card bg={'dark'} className={'mb-2'} key={exp.id}>
                    <Card.Header className={'d-flex align-items-baseline justify-content-between'}>
                      <Card.Title className={'mb-0'}>
                        {exp.name}{' '}
                        <WithTooltip text={'Utenti con questo esperimento attivo'} big={false}>
                          <Badge variant={(exp.usersActive || 0) > 0 ? 'primary' : 'secondary'}>
                            <FontAwesomeIcon icon={faUserCheck} className={'mr-1'} /> {exp.usersActive || 0}
                          </Badge>
                        </WithTooltip>
                      </Card.Title>
                      <small>
                        <Copyable text={exp.id} />
                      </small>
                    </Card.Header>
                    <Card.Body {...innerHtml(exp.description)} />

                    {!!exp.milestones?.length && (
                      <>
                        <hr className={'my-0'} />
                        <Card.Body>
                          <div>Milestones:</div>
                          {exp.milestones.map((milestone, index) => (
                            <div className={'small d-flex align-items-center'} key={index.toString()}>
                              <FontAwesomeIcon icon={milestone.done ? faCheckSquare : faSquare} className={'mr-1'} />
                              <span>{milestone.label}</span>
                            </div>
                          ))}
                        </Card.Body>
                      </>
                    )}

                    <Card.Footer>
                      <div className={'d-flex align-items-center justify-content-between'}>
                        <AdminNotes notes={exp.notes} path={`experiments/${exp.id}`} onSubmit={() => _getExperiments()} context={['experiment', exp.id]} />
                        <Button
                          disabled={loading}
                          size={'sm'}
                          variant={hasExperiment(exp.humanReadableId) ? 'success' : 'primary'}
                          onClick={() => toggleExperiment(exp.id, exp.humanReadableId)}
                        >
                          <FontAwesomeIcon icon={hasExperiment(exp.humanReadableId) ? faCheckSquare : faSquare} className={'mr-2'} />
                          {hasExperiment(exp.humanReadableId) ? 'Attivo' : 'Non attivo'}
                        </Button>
                      </div>
                    </Card.Footer>
                  </Card>
                ))}
            </>
          )}
        </div>
      </Container>

      <Footer />
    </>
  );
};

export default LabComponent;
